module.exports = __webpack_public_path__ + "607da9c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/left-arrow-line.svg
// module id = 1932
// module chunks = 15 17 21 32 36